import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalContainer from '../../components/ModalContainer.jsx';
import DataTable from '../../components/Table/DataTable.jsx';
import Alert from '../../utils/Alert.js';
import { deleteInstallmentService, getInstallmentsOfAnOrderService } from '../../services/installmentsServices.js';
import { convertDateToJalaali } from '../../utils/convertDate.js';
import { Button } from '@mui/material';
import Confirm from '../../utils/Confirm.js';
import AddInstallment from './AddInstallment.jsx';
import InstallmentsActions from './additionFields/InstallmentsActions.jsx';


const Intallments = () => {
    const [installments, setInstallments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [editingId, setEditingId] = useState(null);
    const [orderData, setOrderData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    // const { userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

    const location = useLocation();

    const navigate = useNavigate();

    const installmentsCols = [
        {
            field: "id",
            text: "#"
        },
        {
            field: null,
            text: "مبلغ",
            element: (rowData) => (
                <span>{Number.isNaN(Number(rowData.amount)) ? rowData.amount : Number(rowData.amount).toLocaleString()} تومان</span>
            )
        },
        {
            field: null,
            text: "مهلت پرداخت",
            element: (rowData) => (
                <span className={!rowData.pay_date ? "text-red-500" : ""}>
                    {rowData.pay_date ? convertDateToJalaali(rowData.pay_date) : "مشخص نشده"}
                </span>
            )
        },
        {
            field: null,
            text: "تاریخ تراکنش",
            element: (rowData) => (
                <span className={!rowData.transaction_date ? "text-red-500" : ""}>
                    {rowData.transaction_date ? convertDateToJalaali(rowData.transaction_date) : "مشخص نشده"}
                </span>
            )
        },
        {
            field: null,
            text: "کد پیگیری",
            element: (rowData) => (
                <span className={!rowData.trace_code ? "text-red-500" : ""}>
                    {rowData.trace_code || "ندارد"}
                </span>
            )
        },
        {
            field: null,
            text: "کد پیگیری",
            element: (rowData) => (
                <span className={rowData.is_paid ? "text-green-500" : "text-red-500"}>
                    {rowData.is_paid ? "پرداخت شده" : "پرداخت نشده"}
                </span>
            )
        },
        {
            field: null,
            text: "عملیات‌ها",
            element: (rowData) => (
                <InstallmentsActions
                    rowData={rowData}
                    handleDeleteInstallment={handleDeleteInstallment}
                    setEditingId={setEditingId}
                    setIsOpen={setIsOpen}
                />
            )
        },
    ];

    const handleDeleteInstallment = async (installmentData) => {
        const result = await Confirm("تایید عملیات", `آیا از حذف قسط "${installmentData.id}" مطمئن هستید؟`, "info", true, "لغو", "بله")
        if (result) {
            try {
                const response = await deleteInstallmentService(location.state.code, installmentData.id);
                if (response.status === 204) {
                    setInstallments(prevValue => prevValue.filter(item => item.id !== installmentData.id));
                }
            } catch (error) {

            }
        }
    }

    const handleGetInstallmentsOfOrder = async (orderCode) => {
        try {
            setIsLoading(true);
            const response = await getInstallmentsOfAnOrderService(orderCode);
            if (response.status === 200) {
                setInstallments(response.data);
            }
        } catch (error) {
            Alert(`خطا ${error.response?.status || ""}!`, "در دریافت اقساط مشکلی رخ داده است!\nلطفاً مجدداً امتحان کنید.", "error");
            return navigate(-1)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (location.state) {
            setOrderData(location.state);
            handleGetInstallmentsOfOrder(location.state.code);
        } else {
            return navigate(-1);
        }
    }, []);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={true}
            title="اقساط"
        >
            <DataTable
                tableCols={installmentsCols}
                tableData={installments}
                itemsCount={10}
                title={`اقساط سفارش "${orderData?.code || ""}"`}
                searchField="id"
                isLoading={isLoading}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        setEditingId(null);
                        setIsOpen(true);
                    }}
                >
                    افزودن قسط
                </Button>
                <AddInstallment
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setInstallments={setInstallments}
                    editingId={editingId}
                    setEditingId={setEditingId}
                    orderData={orderData}
                />
            </DataTable>
        </ModalContainer>
    );
}

export default Intallments;
